import React from 'react';

/**
 * WO-26 — the objection line the law work order requires on every page,
 * and the operator identification Article 10 of Ley 34/2002 requires to be
 * permanently available by electronic means.
 *
 * The two sentences are BILAL's prescribed wording (strings A11 and A10,
 * work order of 18 September 2026). They are displayed as written: if the
 * layout cannot hold them, the layout changes, not the words.
 */
export default function LegalFooter({ language = 'en' }) {
  const isRTL = language === 'ar';
  const objection = isRTL
    ? 'للناشرين وأصحاب الحقوق: للاعتراض على أي محتوى، يُرجى مراسلتنا على info@mid2bid.com — ويُحذف المحتوى في غضون 72 ساعة.'
    : 'Publishers and rightholders: to object to content, write to info@mid2bid.com — content is removed within 72 hours.';
  const operator = 'MID2BID is a service operated and published by PASTORIA PROJECT, S.L., CIF B57664179, with registered address at Cno. Son Rapiña 8, 1ºA, 07013 Palma de Mallorca, Spain. Contact: info@mid2bid.com.';
  return (
    <footer
      dir={isRTL ? 'rtl' : 'ltr'}
      className="mt-8 border-t border-border/60 px-4 py-4 text-xs leading-relaxed text-muted-foreground"
      data-testid="legal-footer"
    >
      <p data-testid="legal-footer-objection">{objection}</p>
      <p className="mt-1" data-testid="legal-footer-operator">{operator}</p>
      <p className="mt-1 flex flex-wrap gap-3">
        <a href="/terms-of-service" className="hover:text-primary" data-testid="footer-terms-link">Terms of Service</a>
        <a href="/privacy-policy" className="hover:text-primary">Privacy Policy</a>
        <a href="/cookie-policy" className="hover:text-primary">Cookie Policy</a>
      </p>
    </footer>
  );
}
